import { DateTime } from 'luxon';
import { CHART_TICK_MUTED_COLOR } from '../consts';

interface CustomTickProps {
  x?: number;
  y?: number;
  payload?: { value: string; index: number };
  chartData?: Array<Record<string, unknown> & { date: string }>;
  bandScale?: boolean; // bar charts: every tick is centered under its bar
}

type TextAnchorType = 'start' | 'middle' | 'end' | 'inherit' | undefined;

export const CustomDateTick = ({ x = 0, y = 0, payload, chartData = [], bandScale = false }: CustomTickProps) => {
  if (!payload) return null;

  const dateStr = String(payload.value);
  const index = payload.index ?? 0;
  const current = DateTime.fromISO(dateStr, { zone: 'utc' });

  let label = '';

  if (index === 0) {
    label = current.toFormat('MMM d');
  } else if (index > 0 && chartData.length > 0) {
    const previous = DateTime.fromISO(String(chartData[index - 1].date), { zone: 'utc' });

    label = current.month !== previous.month ? current.toFormat('MMM d') : current.toFormat('d');
  } else {
    label = current.toFormat('MMM d');
  }

  const isFirst = index === 0;
  const isLast = index === chartData.length - 1;

  // Band scale (bars): tick is centered under its bar, so always center.
  // Point scale (line/area): first/last sit on the plot edges, so anchor inward.
  let textAnchor: TextAnchorType = 'middle';

  if (bandScale) {
    textAnchor = 'middle';
  } else if (isFirst) {
    textAnchor = 'start';
  } else if (isLast) {
    textAnchor = 'end';
  }

  return (
    <text
      x={x}
      y={y}
      dy={4}
      textAnchor={textAnchor}
      fill={CHART_TICK_MUTED_COLOR}
      fontSize={12}
    >
      {label}
    </text>
  );
};
